const ORGID = '8f0e4d53-41c5-4d8d-9765-e0b1e625dee1';
const TOKEN = '0516664b-317d-4f18-865a-46be3dd4f0fc';//'6f0563ba-41d2-4e95-9f07-d4b3c2dc8e73';//2022-07-07 change to a designated token to show on the 'Submitted By' column on the Jobs page
const publicToken = '8d296923-9a20-4c11-8a8c-abd643a922cd';

export { ORGID, TOKEN, publicToken };
